<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{'font-weight': 'bold', 'background': '#F0F2F8', 'color': '#333'}"
      element-loading-text="拼命加载中"
      border
      style="width: 100%"
    >
      <!-- <el-table-column
        prop="id"
        width="80"
        label="序号"
      >
      </el-table-column> -->
      <el-table-column
        prop="accountType"
        label="收支类型"
      >
        <template slot-scope="scope">
          {{ ['收入','支出'][Number(scope.row.accountType) - 1] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="projectCodeName"
        label="平台"
      />
      <el-table-column
        prop="amount"
        label="收支金额"
      />
      <el-table-column
        prop="description"
        label="备注"
      />
      <el-table-column
        prop="createTime"
        label="操作时间"
      >
        <template slot-scope="scope">
          {{ setTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pagination.nowPageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  name: 'settlement-list-component',
  data() {
    return {
      supplierId: '',
      tableData: [],
      loading: false,
      // 分页
      pagination: {
        currentPage: 1,
        nowPageSize: 10,
        count: 0,
      },
    };
  },
  mounted() {
    this.supplierId = JSON.parse(localStorage.getItem('userInfo')).suppliersId;
    this.getList();
  },
  methods: {
    // 分页控制
    handleSizeChange(val) {
      this.pagination.nowPageSize = val;
      this.pagination.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$axios({
        method: 'get',
        url: this.$api.settlement.accountlist,
        params: {
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.nowPageSize,
          storeName: this.storeName,
          startTime: this.createStartTime ? this.createStartTime : null,
          endTime: this.createEndTime ? this.createEndTime : null,
          supplierId: this.supplierId,
        },
      }).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.records;
          this.pagination.count = Number(res.data.total);
        } else {
          this.$message(res.error_msg);
        }
        this.loading = false;
      });
    },
    setTime(time) {
      return time ? dayjs(time).format('YYYY-MM-DD HH:mm:ss') : '';
    },
  },
};
</script>
